import type { FaireProductEntity } from "../../entity_types/product";

export const faire_nudge_6: FaireProductEntity = {
  token: "faire_nudge_6",
  type: "product",
  name: "Eucalyptus Candle",
  brandName: "Candle Brand",
  imageUrl:
    "https://images.unsplash.com/photo-1572726729207-a78d6feb18d7?w=100&h=100&fit=crop",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated candle ops mock product",
  tags: ["candle", "ops"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
